export const FORGOT_PASSWORD_TEXTS = {
    TITLE: 'Change Your Password',
    SUBTITLE: 'Enter your email below and we\'ll send you a Reset Link.',
    BUTTON: 'Send Reset Link',
    RETURN_TO_LOGIN: 'Or Login',
    CODE_SENT_MESSAGE: 'We have sent an email to {email} with the password reset link',
    EMAIL_NOT_FOUND_EXCEPTION: 'This email is not in our system. Please enter the correct email.',
    FEDERATED_SIGN_IN_TEXT: 'Click Here to Sign in',
};

export const FORGOT_PASSWORD_TEST_IDS = {
    PAGE: 'FORGOT_PASSWORD_PAGE',
    INPUT_USERNAME: 'FORGOT_PASSWORD_INPUT_USERNAME',
    SUBMIT_BUTTON: 'FORGOT_PASSWORD_SUBMIT_BUTTON',
    EMAIL_ERROR_MESSAGE: 'FORGOT_PASSWORD_EMAIL_ERROR_MESSAGE',
    LINK_TO_LOGIN: 'FORGOT_PASSWORD_LINK_TO_LOGIN',
};

export const FORGOT_PASSWORD_DATA_AUTO_TEST_IDS = {
    PAGE: 'FORGOT_PASSWORD_PAGE',
    INPUT_USERNAME: 'FORGOT_PASSWORD_INPUT_USERNAME',
    SUBMIT_BUTTON: 'FORGOT_PASSWORD_SUBMIT_BUTTON',
    EMAIL_ERROR_MESSAGE: 'FORGOT_PASSWORD_EMAIL_ERROR_MESSAGE',
    LINK_TO_LOGIN: 'FORGOT_PASSWORD_LINK_TO_LOGIN',
};
